
import { Prop, Vue } from 'vue-property-decorator';
export default class UnrecoverableError extends Vue {
  
  @Prop() messageDetail: string | undefined;
  private get errorMessage(): string {
    const errorMessage = this.messageDetail || this.$t('err.network');
    return errorMessage + ' ' + this.$t('err.exit');
  }

  private handleClick(): void {
    this.$emit('exitTestClicked');
  }
}
